import { action as apiAction } from 'api/Api'
import {
  addLabel
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  labelId: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, labelId } = payload

  const optimisticAction = optimisticDispatch(dispatch, addLabel({
    id: cardId,
    labelId,
    index: undefined
  }))

  try {
    await apiAction('AddLabelToCard', {
      cardId,
      labelId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
